import { Card, Tabs } from "@radix-ui/themes";
import { useState } from "react";
import EmailSettings from "./EmailSettings";
import { EsuraApiConnectionProperties } from "./EsuraApiConnectionProperties";
import { ThemeOptionsScreen } from "./ThemeOptionsScreen";
import UploadImages from "./UploadImages";
import { UploadModels } from "./UploadModels";

type ActiveSegmentTab =
  | "Api esura central"
  | "Email"
  | "Imagens"
  | "Tema"
  | "Modelos";

export const SettingsPage = () => {
  const [activeSegment, setActiveSegment] =
    useState<ActiveSegmentTab>("Api esura central");

  return (
    <Card style={{ padding: "20px" }}>
      <Tabs.Root
        value={activeSegment}
        onValueChange={(v) => setActiveSegment(v as ActiveSegmentTab)}
      >
        <Tabs.List>
          <Tabs.Trigger value="Api esura central">
            API Esura Central
          </Tabs.Trigger>
          <Tabs.Trigger value="Email">Email</Tabs.Trigger>
          <Tabs.Trigger value="Imagens">Imagens</Tabs.Trigger>
          <Tabs.Trigger value="Tema">Tema</Tabs.Trigger>
          <Tabs.Trigger value="Modelos">Modelos</Tabs.Trigger>
        </Tabs.List>

        <Tabs.Content value="Api esura central">
          <EsuraApiConnectionProperties />
        </Tabs.Content>

        <Tabs.Content value="Email">
          <EmailSettings />
        </Tabs.Content>
        <Tabs.Content value="Modelos">
          <UploadModels type="CARTAO_ESTUDANTE" />
        </Tabs.Content>

        <Tabs.Content value="Imagens">
          <UploadImages />
        </Tabs.Content>
        <Tabs.Content value="Tema">
          <ThemeOptionsScreen />
        </Tabs.Content>
      </Tabs.Root>
    </Card>
  );
};
